import styled from "styled-components";

export const CourseIconImage = styled.img`
  width: 30px;
  border-radius: 50%;
  height: 30px;
`;
